import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import numberManagementReducer from '@/store/numberManagementSlice';
import userManagementSlice from '@/store/userManagementSlice';
import userReducer from '@/store/userSlice';

const persistConfig = {
    key: 'root',
    version: 1,
    storage,
    // whitelist: ['user', 'numberManagement'] // only these will be persisted
    // blacklist: [] // these will not be persisted
};

const rootReducer = combineReducers({
    numberManagement: numberManagementReducer,
    user: userReducer,
    availableUsers: userManagementSlice,
});

const rootReducerWithReset = (state, action) => {
    if (action.type === 'store/reset') {
        storage.removeItem('persist:root');

        state = undefined;
    }
    return rootReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducerWithReset);

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    FLUSH,
                    REHYDRATE,
                    PAUSE,
                    PERSIST,
                    PURGE,
                    REGISTER,
                ],
            },
        }),
});

export const persistor = persistStore(store);

export const resetStore = () => ({
    type: 'store/reset',
});

export default store;
